var FilterBar = function () {

    this.init = function () {

        $('#filterBarForm').on('submit', function (e) {

            e.preventDefault();

            var counter = 0;

            $('.dropdown-holder .dropdown').each(function () {


                if ($(this).val() == '') {
                    counter++;
                }
            });

            if ($(".dropdown-holder .dropdown").length == counter) {
                $('.dropdown-holder .dropdown').each(function () {
                    $(this).parent().addClass('error')
                });
            }
        });

        $('.dropdown').on('change', function () {
            $('.dropdown').parent().removeClass('error')
        });
    }

    return this.init();
}